import React, {Suspense} from "react";
import {Route, Routes} from "react-router";
import RouteGenerator from "src/Routes/RouteGenerator";
import Page404 from "src/Console/Page404";
import {HomeRoutes} from "src/Routes/HomeRoutes";
import BioSpinner from "src/RCMP/BioSpinner";
import ForgetForm from "src/RCMP/RCMP_formReg_V00.04/ForgetForm";
import RegisterForm from "src/RCMP/RCMP_formReg_V00.04/RegisterForm";

/**
 * step 1004: Application routes will initiate here
 * @returns {Element}
 * @constructor
 */

const MainRoutes = () => {
    return (
        <Suspense
            fallback={
                <div className="text-center">
                    <BioSpinner size='lg' animation={'border'}/>
                </div>
            }
        >
            <Routes>
                {RouteGenerator(HomeRoutes)}
                <Route path="forget" element={<ForgetForm/>}/>
                <Route path="register" element={<RegisterForm />}/>
                <Route path="*" element={<Page404 isLoading={true}/>}/>
            </Routes>
        </Suspense>
    );
};

export default MainRoutes;
